import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export function TABLE__empty() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return (
    <div
      className="flex-center size-full bg-component 
  text-component-item-foreground
  min-h-[50px]"
    >
      {t(i18n_page_settings_workspace.tabs.shared_entities.table_base.placeholder)}
    </div>
  );
}
